import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SideNavbar from './helpers/SideNavbar';
import { useNavigate, Link } from 'react-router-dom';
import { FaTrophy, FaSync } from 'react-icons/fa';

const TopPerformingPosts = () => {
  const navigate = useNavigate();
  const UserID = localStorage.getItem('UserID');
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadTopPosts = async () => {
    if (!UserID) return;
    setLoading(true);
    try {
      const resp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/top-performing-posts/${UserID}`);
      setPosts(resp.data || []);
      setError('');
    } catch (e) {
      console.error('Failed to load top posts', e);
      setError('Failed to load top-performing posts');
      setPosts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTopPosts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [UserID]);

  return (
    <SideNavbar>
      <div className="container-fluid">
        <div className="card border-0 shadow-sm" style={{ borderRadius: '12px', marginTop: '20px' }}>
          <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center p-3">
            <div className="d-flex align-items-center">
              <div className="me-3">
                <div style={{
                  width: '40px', height: '40px', borderRadius: '8px', background: '#f8f9fa', display: 'flex',
                  alignItems: 'center', justifyContent: 'center', border: '1px solid #e9ecef'
                }}>
                  <FaTrophy size={20} style={{ color: '#2e3192' }} />
                </div>
              </div>
              <div className="d-flex align-items-center">
                <Link to="/home" style={{ textDecoration: 'none', color: '#2e3192', marginRight: '15px' }}>
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </Link>
                <h5 className="mb-0 fw-bold me-2" style={{ fontSize: '1.3rem', color: '#2e3192' }}>Top Performing Posts</h5>
                {!loading && (
                  <span className="badge bg-light text-dark" style={{ fontSize: '12px', fontWeight: '600' }}>{posts.length}</span>
                )}
              </div>
            </div>
            <div className="d-flex align-items-center">
              <button className="btn btn-sm btn-outline-primary me-2" onClick={loadTopPosts} disabled={loading}
                style={{ fontSize: '12px', padding: '6px 12px', borderRadius: '8px' }} title="Refresh">
                <FaSync size={10} />
              </button>
            </div>
          </div>

          <div className="card-body p-4">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3 text-muted">Loading top-performing posts...</p>
              </div>
            ) : error ? (
              <div className="text-center py-5">
                <p className="text-danger">{error}</p>
                <button className="btn btn-primary btn-sm" onClick={loadTopPosts}>Try Again</button>
              </div>
            ) : posts.length === 0 ? (
              <div className="text-center py-5">
                <p className="text-muted">No top-performing posts found.</p>
              </div>
            ) : (
              <div className="row">
                {posts.slice(0, 10).map((post, index) => (
                  <div key={`top-performing-${post.ContentId || post.PostId || index}`} className="col-md-4 mb-4">
                    <div
                      className="card border-0 shadow-sm h-100"
                      style={{
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        padding: '16px',
                        cursor: post.LinkdinPostId ? 'pointer' : 'default',
                        transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                        minHeight: '250px'
                      }}
                      onClick={() => {
                        if (post.LinkdinPostId) {
                          const facebookPostId = post.FacebookPostId || null;
                          const url = facebookPostId 
                            ? `/viewpostcomments/${post.LinkdinPostId}?facebookPostId=${encodeURIComponent(facebookPostId)}`
                            : `/viewpostcomments/${post.LinkdinPostId}`;
                          navigate(url);
                        }
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                      }}
                    >
                      <div className="mb-3">
                        {post.PostImage && post.PostImage !== '/assets/default-post-image.png' ? (
                          <img
                            src={post.PostImage}
                            alt={post.ShortContent || 'Post Image'}
                            style={{ width: '100%', height: '120px', objectFit: 'cover', borderRadius: '6px' }}
                            onError={(e) => { e.target.style.display = 'none'; }}
                          />
                        ) : (
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{ width: '100%', height: '120px', backgroundColor: '#e9ecef', borderRadius: '6px' }}
                          >
                            <i className="fa fa-file-image-o" style={{ fontSize: '24px', color: '#6c757d' }}></i>
                          </div>
                        )}
                      </div>
                      <div style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column' }}>
                        <div
                          className="small fw-bold mb-3"
                          style={{
                            fontSize: '12px',
                            color: '#2e3192',
                            lineHeight: '1.5',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: 'vertical',
                            flex: '1 1 auto'
                          }}
                        >
                          {post.ShortContent || post.Content || 'Top Performing Content'}
                        </div>
                        <div className="mt-auto">
                          {/* LinkedIn Metrics */}
                          <div className="d-flex justify-content-between text-muted mb-1" style={{ fontSize: '11px' }}>
                            <span>{(post.LikeCount || 0)} likes</span>
                            <span>{(post.CommentCount || 0)} comments</span>
                          </div>
                          {/* Facebook Metrics - Show if FacebookPostId exists */}
                          {post.FacebookPostId && (
                            <div className="d-flex justify-content-between" style={{ 
                              fontSize: '10px', 
                              color: '#6c757d',
                              borderTop: '1px solid #e9ecef',
                              paddingTop: '4px',
                              marginTop: '4px'
                            }}>
                              <span>FB: {(post.FacebookLikeCount || 0)} likes</span>
                              <span>{(post.FacebookCommentCount || 0)} comments</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </SideNavbar>
  );
};

export default TopPerformingPosts;


